<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Formulários</h1>
    
    <div class="mb-2 mt-3">
      <SGPFormSelectComponent
        name="exibirItensDeletados"
        :listaDeOptions="opcoesSelect"
        v-model="exibirItensDeletados"
        :optionLabel="'nome'"
        placeholder="Visualizar Itens Deletados"
        :error="validationErrors.first('exibirItensDeletados')"
        data-vv-as="Visualizar Itens Deletados"
        :optionSelecione="'Não'"
        @change="filtrarFormulariosDeletados($event)"
      />
    </div>

    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovo"/>

    <SGPTabelaAvancadaComponent
      v-if="listaDeFormularios.length"
      :colunas="colunas"
      :dados="listaDeFormularios"
      :key="JSON.stringify(listaDeFormularios)"
      @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
      @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
      @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado"
      @sgpTabelaRestaurarSelecionadoEmit="restaurarSelecionado"
      selecionarColunas
      :filtroText="true"
    />

    <SGPAlertaComponent v-else/>

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="lg"
      titulo="Formulário"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioCtrlFormulariosComponent
        :tipoFormulario="tipoFormulario"
        :formularioSelecionado="formularioSelecionado"
      />
    </SGPModalComponent>

    <SGPConfirmacaoDelecaoComponent
      v-if="deletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />

    <SGPLoadingComponent v-if="loadingFormularios"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioCtrlFormulariosComponent from '../components/FormularioCtrlFormulariosComponent.vue'

export default {
  name: 'CtrlFormulariosPage',
  
  components: {
    FormularioCtrlFormulariosComponent
  },

  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      formulariosSelecionados: [],
      abrirModal: false,
      deletarDados: false,
      tipoFormulario: 'salvar',
      formularioSelecionado: {},
      opcoesSelect: [
        { id: true, nome: 'Sim' },
        { id: false, nome: 'Não' }
      ],
      exibirItensDeletados: ''
    }
  },

  created () {
    this.listarFormularios({
      trashed: this.exibirItensDeletados
    })
  },

  computed: {
    ...mapGetters('ctrlFormularios', [
      'listaDeFormularios',
      'loadingFormularios'
    ]),

    colunas () {
      return [
        { key: 'selecionar', label: '', sortable: false },
        { key: 'titulo', label: 'Título', sortable: true },
        { key: 'url', label: 'URL', sortable: true },
        { key: 'metodo', label: 'Método', sortable: true }
      ]
    }
  },

  methods: {
    ...mapActions('ctrlFormularios', [
      'listarFormularios',
      'excluirFormularios',
      'restaurarFormulario'
    ]),

    gerenciadorDeSelecionados (selecionados) {
      this.formulariosSelecionados = selecionados
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar'
      this.formularioSelecionado = this.formulariosSelecionados[0]
      this.abrirModal = true
    },

    restaurarSelecionado (item) {
      this.restaurarFormulario(item.id)
    },

    deletarSelecionado () {
      this.deletarDados = true
    },

    cancelarDelecao () {
      this.deletarDados = false
    },

    confirmarDelecao () {
      this.excluirFormularios(this.formulariosSelecionados)
      this.deletarDados = false
    },

    adicionarNovo () {
      this.formularioSelecionado = {}
      this.tipoFormulario = 'salvar'
      this.abrirModal = true
    },

    fecharModal () {
      this.abrirModal = false
    },

    filtrarFormulariosDeletados (event) {
      if (typeof event === 'undefined') return false

      const payload = {
        trashed: this.exibirItensDeletados
      }

      this.listarFormularios(payload)
    }
  }
}
</script>